export const environment = {

  /*========================================
                  Variables
  =========================================*/

  production: false,
  useProxy: true,
  release: '1.19.3',
  defaultLanguage: 'fr',
  vapidPublicKey: 'BJLhmb9xZEVlI94EXWfott7Nn6XS8JVpfkIOxQfCau5jDrlkRgUp9RzUBDuLbXlQK3lr5koAoDFozXV9ehp_Y2A',

  /*========================================
                     API
  =========================================*/

  api: {
    protocol: 'https',
    url: 'admin.vop-carshare.fr'
  },

  pdfready: {
    protocol: 'http',
    url: 'localhost:3000'
  },

  /*========================================
                   Leaflet
  =========================================*/

  /*========================================
                  Planner
  =========================================*/

  plannerWindowDays: 200,
  testMode: true,

  /*========================================
                   Leaflet
  =========================================*/

  leaflet: {
    tileLayer: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    subdomains: 'abcd',
    maxZoom: 19
  }

};